/// <amd-module name="Agile/Directory/Redux/getDirectoryProviderProps" />
import { IDirectoryArtifact, IDirectoryContext, IDirectoryViewState } from "Agile/Directory/DirectoryContracts";
import { getDefaultState as getDefaultArtifactState } from "Agile/Directory/Redux/Artifacts/ArtifactReducer";
import { DirectoryModule } from "Agile/Directory/Redux/DirectoryModule";
import { getDefaultState as getDefaultFavoriteState } from "Agile/Directory/Redux/Favorites/FavoritesReducer";
import { getDefaultState as getDefaultUIState } from "Agile/Directory/Redux/UIState/DirectoryUIStateReducer";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { getTfsPageDataModule } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageData";
import { IVssPageContext } from "VSS/Platform/Context";
import { IRootProviderProps } from "VSS/Redux/Deprecated/RootProvider";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";

export interface IDirectorySagaContext {
    pageContext: IVssPageContext;
    directoryContext: IDirectoryContext;
}

export function getDirectoryProviderProps<T extends IDirectoryArtifact>(
    directoryContext: IDirectoryContext,
    hubViewState: VssHubViewState,
    pageContext: IVssPageContext,
    telemetryArea: string,
    additionalModules?: ISagaModule<any>[]
): IRootProviderProps<IDirectorySagaContext, IDirectoryViewState<T>> {
    const initialState = {
        directoryState: {
            directoryArtifactState: getDefaultArtifactState(),
            favoriteState: getDefaultFavoriteState(),
            uiState: getDefaultUIState()
        },
        hubViewState: {
            currentFilterState: {},
            currentPivot: "",
            currentViewOptions: {
                fullScreen: true
            }
        }
    } as any;

    const sagaContext = { directoryContext, pageContext };
    additionalModules = additionalModules || [];
    return {
        initialState,
        sagaContext,
        scenarioName: telemetryArea,
        hubViewState,
        ttiSplitTimingName: "directoryContent",
        modules: [getTfsPageDataModule(), DirectoryModule, ...additionalModules]
    };
}
